import "esbuild-css-modules-plugin-ns-css:src/artifacts/shared/styles/icon/info.module.css";

export default {
  "icon": "info-module__icon_mj0x6q__010"
};
      